export const USER_BLOCKS_UPDATED_EVENT = "userBlocksUpdated";

type BlocksUpdateEventTarget = Pick<
  EventTarget,
  "addEventListener" | "removeEventListener"
>;

export function dispatchUserBlocksUpdated(target?: EventTarget): boolean {
  const eventTarget =
    target ?? (typeof window !== "undefined" ? window : null);

  if (!eventTarget) {
    return false;
  }

  return eventTarget.dispatchEvent(new Event(USER_BLOCKS_UPDATED_EVENT));
}

export function subscribeToUserBlocksUpdated(
  target: BlocksUpdateEventTarget,
  handler: EventListener,
): () => void {
  target.addEventListener(USER_BLOCKS_UPDATED_EVENT, handler);

  return () => {
    target.removeEventListener(USER_BLOCKS_UPDATED_EVENT, handler);
  };
}
